export default __webpack_public_path__ + "static/media/CorrectBling1.9178d5b6.mp3";